import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EpsTrendItem, StockStatisticsItem, SecurityValuationItem, EarningsItem, EarningsEstemateItem, RevenueEstemateItem } from "./types";
import { EtfSummaryItem, EtfCompositionItem, EtfPerformanceItem } from "./types";

type SecurityStatisticData = {
	displaySecurityEpsTrend?: EpsTrendItem;
	displaySecurityStatistics?: StockStatisticsItem;
	displaySecurityValuation?: SecurityValuationItem;
	displaySecurityEarnings?: EarningsItem;
	displaySecurityEarningsEstimate?: EarningsEstemateItem;
	displaySecurityRevenueEstimate?: RevenueEstemateItem;
	displayEtfSummary?: EtfSummaryItem;
	displayEtfComposition?: EtfCompositionItem;
	displayEtfPerformance?: EtfPerformanceItem;
};

const initialState: SecurityStatisticData = {
};

const name = "securityStatistics";

const statisticsDatalice = createSlice({
	name,
	initialState,
	reducers: {
		setDisplayedEpsTrend: (state, action: PayloadAction<EpsTrendItem | undefined>) => ({
			...state,
			displaySecurityEpsTrend: action.payload,
		}),
		setDisplayedStatisatics: (state, action: PayloadAction<StockStatisticsItem | undefined>) => ({
			...state,
			displaySecurityStatistics: action.payload,
		}),
		setDisplayedValuation: (state, action: PayloadAction<SecurityValuationItem | undefined>) => ({
			...state,
			displaySecurityValuation: action.payload,
		}),
		setDisplayedEarnings: (state, action: PayloadAction<EarningsItem | undefined>) => ({
			...state,
			displaySecurityEarnings: action.payload,
		}),
		setDisplayedEarningsEstimate: (state, action: PayloadAction<EarningsEstemateItem | undefined>) => ({
			...state,
			displaySecurityEarningsEstimate: action.payload,
		}),
		setDisplayedRevenueEstimate: (state, action: PayloadAction<RevenueEstemateItem | undefined>) => ({
			...state,
			displaySecurityRevenueEstimate: action.payload,
		}),
		setDisplayedEtfSummary: (state, action: PayloadAction<EtfSummaryItem | undefined>) => ({
			...state,
			displayEtfSummary: action.payload,
		}),
		setDisplayedEtfComposition: (state, action: PayloadAction<EtfCompositionItem | undefined>) => ({
			...state,
			displayEtfComposition: action.payload,
		}),
		setDisplayedEtfPerformance: (state, action: PayloadAction<EtfPerformanceItem | undefined>) => ({
			...state,
			displayEtfPerformance: action.payload,
		}),
	},
});

export const { setDisplayedEpsTrend, setDisplayedStatisatics, setDisplayedValuation, setDisplayedEarnings, setDisplayedEarningsEstimate,
	setDisplayedRevenueEstimate, setDisplayedEtfSummary, setDisplayedEtfComposition, setDisplayedEtfPerformance } = statisticsDatalice.actions;

export default statisticsDatalice.reducer;


